import {AutoEncoder, BooleanDecoder, field} from '@simonbackx/simple-encoding'

export class EncodeableBoolean extends AutoEncoder {
    @field({decoder: BooleanDecoder})
    value: boolean
}
